import { createContext, useContext, useMemo, useState } from 'react';

import { MessageCenterContextType } from './MessageCenterContext.interface';

const MessageCenterContext = createContext<MessageCenterContextType>({
    searchQuery: '',
    setSearchQuery: () => {},
});

export const useMessageCenterContext = () => useContext(MessageCenterContext);

export function MessageCenterContextProvider({ children }: { children: React.ReactNode }) {
    const [searchQuery, setSearchQuery] = useState<string>('');

    const value = useMemo(
        () => ({
            searchQuery,
            setSearchQuery,
        }),
        [searchQuery]
    );

    return <MessageCenterContext.Provider value={value}>{children}</MessageCenterContext.Provider>;
}
